import ETC_AXIOS from '../api/etc.axios'
import APP from '../config/app.config'
import ETC from '../config/etc.config'
import axios from 'axios'

export default {
  // startApply() {
  //   return ETC_AXIOS.post(APP.HTTP_URL2 + '/apply/start-apply')
  // },
  getQA (data) {
    const t = (new Date().getTime() / 100000).toFixed(0)
    return axios.get(`https://etc-file.etczs.net/api_resource_cache%2FIssuer%2Fissuer_question_${data.page_id}_${data.card_id || '0'}.json?t=${t}`).then(res => {
      if (res.data && res.data.code === 0) {
        return res.data.data
      }
      return {}
    })
    // return ETC_AXIOS.post('/no-login/get-issuer-question', data)
  },
  getAgreement (data) {
    const t = (new Date().getTime() / 100000).toFixed(0)
    return axios.get(`https://etc-file.etczs.net/api_resource_cache%2FIssuer%2F${data.type}_${data.issuer_id}.json?t=${t}`).then(res => {
      if (res.data && res.data.code === 0) {
        return res.data.data
      }
      return {}
    })
    // return ETC_AXIOS.post('/profile/get-issuer-protocol', data)
  },
  adActions (data) {
    return ETC_AXIOS.post(APP.HTTP_URL2 + '/no-login/users-wechat-ad-actions', {
      openid: localStorage.getItem(ETC.LOCAL_STORAGE_KEY.UUID),
      third_code: localStorage.getItem(ETC.LOCAL_STORAGE_KEY.UUID),
      aid: 'gdt',
      version: APP.VERSION,
      url: '/goodsDetail',
      pl: 41,
      third_type: ETC.APP_LOGIN_TYPES[localStorage.getItem(ETC.LOCAL_STORAGE_KEY.APP_FROM_CHANNEL)],
      entry: localStorage.getItem(ETC.LOCAL_STORAGE_KEY.ENTRY),
      ...data
    })
  }
}
